export const css = {
    root: '_1lrjZx0O',
    stem: '_26GUz1DS',
    answerPrompt: '_1SpihkN6',
    feedback: '_1gcb69hE',
    hintback: '_3a2z1Ojn',
    actions: '_-tReO13',
    oneaction: 'MnforGxK',
    pressed: '_1lzgAQAY',
    timerblock: '_23JhjuDa',
    timer: '_2TxoFv5S',
    actionIcon: '_3omJxU4J',
    primaryButton: '_1mOeBVdd',
    secondaryButton: '_3LzYsk-W',
    ' _key': 'quiz-widgets/numeric-entry'
};
export default css;
